<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Catalogue des produits</h1>
    </div>

    <div class="row row-cards">
      <div class="col-xl-3 col-lg-4">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Catégories</div>
          </div>
          <div class="card-body">
            <ul class="list-group">
              <li
                  v-for="cat in categories"
                  :key="cat.code"
                  class="list-group-item border-0 p-0"
              >
                <a href="javascript:void(0)" @click="selectedCategory = cat.code">
                  <i class="fe fe-chevron-right"></i> {{ cat.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="card-title">Plage de prix</div>
          </div>
          <div class="card-body">
            <label class="custom-control custom-radio mb-0 mt-1">
              <input type="radio" class="custom-control-input" value="low" v-model="selectedPriceRange">
              <span class="custom-control-label">Jusqu'à $500</span>
            </label>
            <label class="custom-control custom-radio mb-0 mt-1">
              <input type="radio" class="custom-control-input" value="mid" v-model="selectedPriceRange">
              <span class="custom-control-label">$500 - $1000</span>
            </label>
            <label class="custom-control custom-radio mb-0 mt-1">
              <input type="radio" class="custom-control-input" value="high" v-model="selectedPriceRange">
              <span class="custom-control-label">$1000 - $1500</span>
            </label>
            <label class="custom-control custom-radio mb-0 mt-1">
              <input type="radio" class="custom-control-input" value="ultra" v-model="selectedPriceRange">
              <span class="custom-control-label">Plus de $2000</span>
            </label>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Couleurs</h3>
          </div>
          <div class="card-body">
            <div class="row gutters-xs">
              <div class="col-auto" v-for="color in colorOptions" :key="color">
                <label class="colorinput">
                  <input type="radio" name="color" :value="color" v-model="selectedColor" class="colorinput-input">
                  <span class="colorinput-color" :class="'bg-' + color"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-9 col-lg-8">
        <div class="row mb-3">
          <div class="col-xl-6">
            <input type="text" class="form-control" placeholder="Recherche..." v-model="searchText">
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-xl-4 col-sm-6" v-for="product in paginatedProducts" :key="product.id">
            <div class="card">
              <div class="product-grid6">
                <div class="product-image6 p-5">
                  <a href="shop-description.html">
                    <img
                        class="img-fluid br-7 w-100"
                        :src="product.images?.[0]?.url || 'https://www.tiffincurry.ca/wp-content/uploads/2021/02/default-product.png'"
                        :alt="product.name"
                    >               </a>
                </div>
                <div class="card-body pt-0 text-center">
                  <h1 class="title fw-bold fs-20">{{ product.name }}</h1>
                  <div class="price"> ${{ product.referencePrice }}</div>
                  <div class="stock mt-1">
    <span class="badge"
          :class="{
            'bg-success': product.stockQuantity > 10,
            'bg-warning': product.stockQuantity > 0 && product.stockQuantity <= 10,
            'bg-danger': product.stockQuantity === 0
          }">
      {{ product.stockQuantity > 0 ? product.stockQuantity + ' en stock' : 'Rupture de stock' }}
    </span>
                  </div>
                </div>

                <div class="card-footer text-center">
                  <button
                      class="btn btn-primary mb-1"
                      :disabled="product.stockQuantity === 0"
                      :class="{ 'btn-disabled': product.stockQuantity === 0 }"
                      @click="addToCart(product)"
                  >
                    <i class="fe fe-shopping-cart mx-2"></i>Ajouter au panier
                  </button>
                  <a href="wishlist.html" class="btn btn-outline-primary mb-1">
                    <i class="fe fe-heart mx-2"></i>Ajouter à la liste de souhaits
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-4">
          <ul class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <a class="page-link" href="javascript:void(0)" @click="currentPage--">Précédent</a>
            </li>

            <li
                v-for="page in totalPages"
                :key="page"
                class="page-item"
                :class="{ active: currentPage === page }"
            >
              <a class="page-link" href="javascript:void(0)" @click="currentPage = page">{{ page }}</a>
            </li>

            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <a class="page-link" href="javascript:void(0)" @click="currentPage++">Suivant</a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";

  export default {
    name: "ShopCatalogue",
    data() {
      return {
        categories: [],
        products: [],
        selectedCategory: null,
        selectedPriceRange: null,
        selectedColor: null,
        searchText: "",
        colorOptions: ["azure", "indigo", "purple", "pink", "red", "orange", "yellow", "lime", "green"],
        currentPage: 1,
        itemsPerPage: 6,
      };
    },
    computed: {
      paginatedProducts() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredProducts.slice(start, end);
      },
      totalPages() {
        return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
      },
      filteredProducts() {
        return this.products.filter(product => {
          const matchCategory = !this.selectedCategory || product.categoryCode === this.selectedCategory;
          const matchSearch = !this.searchText || product.name.toLowerCase().includes(this.searchText.toLowerCase());
          const matchColor = !this.selectedColor || product.color === this.selectedColor; // Adapter selon ton modèle
          const matchPrice = this.matchPriceRange(product.referencePrice);
          return matchCategory && matchSearch && matchColor && matchPrice;
        });
      }
    },
    watch: {
      selectedCategory() {
        this.currentPage = 1;
      },
      selectedColor() {
        this.currentPage = 1;
      },
      selectedPriceRange() {
        this.currentPage = 1;
      },
      searchText() {
        this.currentPage = 1;
      }
    },
    methods: {
      ...mapMutations('cart', ['addItem']),
      loadCategories() {
        this.$loading(true);
        this.$http
            .get("/registry/categories")
            .then(({ data }) => {
              this.categories = data;
            })
            .catch(err => {
              console.error("Erreur lors du chargement des catégories :", err);
            })
            .finally(() => this.$loading(false));
      },
      loadProducts() {
        this.$loading(true);
        this.$http
            .get("/products")
            .then(({ data }) => {
              this.products = data;
            })
            .catch(err => {
              console.error("Erreur lors du chargement des produits :", err);
            })
            .finally(() => this.$loading(false));
      },
      matchPriceRange(price) {
        if (!this.selectedPriceRange) return true;
        const ranges = {
          low: price <= 500,
          mid: price > 500 && price <= 1000,
          high: price > 1000 && price <= 1500,
          ultra: price > 2000
        };
        return ranges[this.selectedPriceRange];
      },
      addToCart(product) {
        this.addItem({ ...product, quantity: 1 });

        this.$toast.success(`${product.name} ajouté au panier !`);

      }
    },
    mounted() {
      this.loadCategories();
      this.loadProducts();
    }
  };
</script>

<style scoped>
.stock .badge {
  font-size: 0.9rem;
  padding: 5px 10px;
}

.btn-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.page-container {
  padding: 20px;
}
</style>